import { render, staticRenderFns } from "./Campus-Layout.vue?vue&type=template&id=62f3f730&scoped=true"
import script from "./Campus-Layout.vue?vue&type=script&lang=js"
export * from "./Campus-Layout.vue?vue&type=script&lang=js"
import style0 from "./Campus-Layout.vue?vue&type=style&index=0&id=62f3f730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f3f730",
  null
  
)

export default component.exports